import { FC, useEffect } from 'react';
import { Box } from '@mui/system';

import { AppPreloader } from 'src/components/app-preloader';
import { useGetZendeskSsoUrl } from 'src/features/support-hub/hooks/useGetZendeskSsoUrl';
import { Page404 } from 'src/pages/page404';

export const SupportHubSsoPage: FC = () => {
    const { mutate: getZendeskSsoUrl, error } = useGetZendeskSsoUrl();

    useEffect(() => {
        getZendeskSsoUrl();
    }, [getZendeskSsoUrl]);

    if (error) {
        return <Page404 />;
    }

    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
            <AppPreloader size="big" showLogo css={{ flex: 1 }} />
        </Box>
    );
};
